import type { ClientEventName } from '@otryad/shared';
import { useEffect } from 'react';

import { trpc } from './trpc';

/**
 * Клиентский трекинг (BLUEPRINT Stage 13, задача 1): события, которых сервер сам не видит —
 * «открыл приложение» и «начал онбординг». Остальное пишет API. Ошибка отправки молчит:
 * аналитика не должна ломать экран.
 *
 * Одно и то же событие за сессию отправляется один раз (React StrictMode вызывает эффекты
 * дважды, а по deep link экран может смонтироваться повторно).
 */

const sent = new Set<string>();

export function useTrackOnce(name: ClientEventName, props?: Record<string, string | number>): void {
  const track = trpc.analytics.track.useMutation();
  // мутация меняется между рендерами — эффект должен зависеть только от имени события
  const mutate = track.mutate;

  useEffect(() => {
    if (sent.has(name)) return;
    sent.add(name);
    mutate({ name, props }, { onError: () => sent.delete(name) });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);
}

/** Для тестов и повторного входа после сброса dev-данных. */
export function resetTracked(): void {
  sent.clear();
}
